// // import React, { useState, useEffect, useCallback } from 'react';

// // const TimeCountDown = ({ dateClass }) => {
// //   const countdownDate = new Date('08/09/2025').getTime();
// //   const [timeLeft, setTimeLeft] = useState({
// //     days: '00',
// //     hours: '00',
// //     minutes: '00',
// //     seconds: '00',
// //   });

// //   const updateTime = useCallback(() => {
// //     const currentTime = new Date().getTime();
// //     const distance = countdownDate - currentTime;

// //     if (distance < 0) {
// //       setTimeLeft({ days: '00', hours: '00', minutes: '00', seconds: '00' });
// //       return;
// //     }

// //     const days = Math.floor(distance / (1000 * 60 * 60 * 24));
// //     const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
// //     const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
// //     const seconds = Math.floor((distance % (1000 * 60)) / 1000);

// //     setTimeLeft({
// //       days: String(days).padStart(2, '0'),
// //       hours: String(hours).padStart(2, '0'),
// //       minutes: String(minutes).padStart(2, '0'),
// //       seconds: String(seconds).padStart(2, '0'),
// //     });
// //   }, [countdownDate]);

// //   useEffect(() => {
// //     const interval = setInterval(updateTime, 1000);
// //     return () => clearInterval(interval);
// //   }, [updateTime]);

// //   return (
// //     <ul className={`countdown_timer_block unordered_list justify-content-center ${dateClass}`}>
// //       {['Days', 'Hours', 'Min', 'Sec'].map((label, index) => {
// //         const timeValues = [timeLeft.days, timeLeft.hours, timeLeft.minutes, timeLeft.seconds];
// //         return (
// //           <li className="time-section" key={label}>
// //             <span className="time">{timeValues[index]}</span>
// //             <small className="time-text">{label}</small>
// //           </li>
// //         );
// //       })}
// //     </ul>
// //   );
// // };

// // export default TimeCountDown;

// "use client"

// import { useState, useEffect } from "react"

// const TimeCountDown = ({ targetDate }) => {
//   const [timeLeft, setTimeLeft] = useState({
//     days: 0,
//     hours: 0,
//     minutes: 0,
//     seconds: 0,
//   })

//   useEffect(() => {
//     // Default target date if none provided
//     const defaultTarget = new Date()
//     defaultTarget.setDate(defaultTarget.getDate() + 30) // 30 days from now

//     const target = targetDate ? new Date(targetDate) : defaultTarget

//     const timer = setInterval(() => {
//       const now = new Date().getTime()
//       const distance = target.getTime() - now

//       if (distance > 0) {
//         const days = Math.floor(distance / (1000 * 60 * 60 * 24))
//         const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
//         const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
//         const seconds = Math.floor((distance % (1000 * 60)) / 1000)

//         setTimeLeft({ days, hours, minutes, seconds })
//       } else {
//         setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 })
//         clearInterval(timer)
//       }
//     }, 1000)

//     return () => clearInterval(timer)
//   }, [targetDate])

//   return (
//     <div className="countdown_timer">
//       <ul className="countdown_list unordered_list justify-content-center">
//         <li>
//           <div className="countdown_item">
//             <span className="countdown_number">{String(timeLeft.days).padStart(2, "0")}</span>
//             <span className="countdown_label">Days</span>
//           </div>
//         </li>
//         <li>
//           <div className="countdown_item">
//             <span className="countdown_number">{String(timeLeft.hours).padStart(2, "0")}</span>
//             <span className="countdown_label">Hours</span>
//           </div>
//         </li>
//         <li>
//           <div className="countdown_item">
//             <span className="countdown_number">{String(timeLeft.minutes).padStart(2, "0")}</span>
//             <span className="countdown_label">Minutes</span>
//           </div>
//         </li>
//         <li>
//           <div className="countdown_item">
//             <span className="countdown_number">{String(timeLeft.seconds).padStart(2, "0")}</span>
//             <span className="countdown_label">Seconds</span>
//           </div>
//         </li>
//       </ul>
//     </div>
//   )
// }

// export default TimeCountDown
"use client";

import { useState, useEffect } from "react";

const TimeCountDown = ({ targetDate, dateClass = "" }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
  });

  useEffect(() => {
    const defaultTarget = new Date();
    defaultTarget.setDate(defaultTarget.getDate() + 30);

    const target = targetDate ? new Date(targetDate) : defaultTarget;

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = target.getTime() - now;

      if (distance > 0) {
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        setTimeLeft({
          days: String(days).padStart(2, "0"),
          hours: String(hours).padStart(2, "0"),
          minutes: String(minutes).padStart(2, "0"),
          seconds: String(seconds).padStart(2, "0"),
        });
      } else {
        setTimeLeft({
          days: "00",
          hours: "00",
          minutes: "00",
          seconds: "00",
        });
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  return (
    <ul className={`countdown_timer_block unordered_list justify-content-center ${dateClass}`}>
      {["Days", "Hours", "Min", "Sec"].map((label, index) => {
        const timeValues = [timeLeft.days, timeLeft.hours, timeLeft.minutes, timeLeft.seconds];
        return (
          <li className="time-section" key={label}>
            <span className="time">{timeValues[index]}</span>
            <small className="time-text">{label}</small>
          </li>
        );
      })}
    </ul>
  );
};

export default TimeCountDown;

